var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialTiktok = function SvgSocialTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M433.985 212.84a196.98 196.98 0 0 1-115.126-36.806v167.593a152.43 152.43 0 0 1-99.02 142.71A152.431 152.431 0 0 1 32.376 271.014a152.426 152.426 0 0 1 154.984-78.429v84.294a69.972 69.972 0 0 0-77.412 108.145 69.973 69.973 0 0 0 126.39-41.397V16h82.521a113.5 113.5 0 0 0 1.744 20.79 114.57 114.57 0 0 0 50.553 75.225 113.87 113.87 0 0 0 62.829 18.886z"
  })));
};
export default SvgSocialTiktok;